import {Navigate, createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute("/_app/sales/offers/templates/$offerTemplateId/details/")({
  component: RouteComponent,
});
function RouteComponent() {
  const {offerTemplateId} = Route.useParams();
  return (
    <Navigate replace to="/sales/offers/templates/$offerTemplateId" params={{offerTemplateId}} />
  );
}
